
import { useRouter } from "next/router"
import { useTranslation } from "lib/i18n/translation"
import { useModal } from "lib/modal"
import Gtm from "lib/gtm"

import CineClub from "components/common/cineclub"
import { baseClub } from "components/common/skeleton"
import Products from "components/common/products"
import { Description } from "components/cine-club/description"
import { Others } from "components/cine-club/others"
import { Intro } from "components/cine-club/intro"
import { Focus } from "components/cine-club/focus"
import { Short } from "components/cine-club/short"
import { OtherOverlay } from "components/modals/cineclub-others"

export default ({ }) => {
	return (
		<CineClub
			renderLoading={() => (
				<Content clubs={baseClub.children.items} loading={true} />
			)}
		>
			{clubs => <Content clubs={clubs} />}
		</CineClub>
	)
}

const Content = ({ clubs, loading = false }) => {
	const { c } = useTranslation("common")
	const { show } = useModal()

	const showOther = (club, clubs, index) => {
		if (!club) return

		const currentIndex = clubs.map(c => c.id).indexOf(club.id)
		const next = currentIndex !== 0 ? clubs[currentIndex - 1] : null
		const previous = (currentIndex !== clubs.length - 1) ? clubs[currentIndex + 1] : null

		show({
			id: `other-club-${club.id}`,
			children: <OtherOverlay club={club} clubs={clubs} index={index} />,
			className: "is-archive slide right",
			footerClassName: "fixed",
			footer: clubs.length > 1
				&& (
					<nav className="buttons full">
						<a
							href="#"
							onClick={e => { e.preventDefault(); showOther(previous, clubs, index - 1) }}
							rel="nofollow noopener"
							title={c("show-previous")}
							className={`previous ${previous ? "" : "disabled"}`}
						>
							{c("previous")}
						</a>
						<a
							href="#"
							onClick={e => { e.preventDefault(); showOther(next, clubs, index + 1) }}
							rel="nofollow noopener"
							title={c("show-next")}
							className={`next ${next ? "" : "disabled"}`}
						>
							{c("next")}
						</a>
					</nav>
				)
		})
	}

	const current = clubs[0]
	const hasFilm = current.products.items.length > 0
	const router = useRouter()
	const url = router ? router.asPath : null

	return (
		<>
			<Gtm pageType="Ciné-club" pagePath={url} pageTitle={c("cine-club")} />
			<Intro key={`intro-${loading ? "loading" : ""}-club-${current.id}`} club={current} loading={loading} />
			{hasFilm
				&& <>
					<Products products={current.products.items} loading={loading}>
						{([film], loading) => {
							return (
								<>
									<Focus film={film} loading={loading || !film} />
									<Short film={film} loading={loading || !film} />
									<Description
										club={current}
										film={film}
										loading={loading || !film}
									/>
									<Others
										clubs={clubs}
										current={current}
										loading={loading}
										showOther={showOther}
									/>
								</>
							)
						}}
					</Products>
				</>
			}
		</>
	)
}
